<template>
  <v-dialog v-model="show" max-width="400px" persistent>
    <v-card>
      <v-card-title style="word-break: normal !important; justify-content: center">{{ modalTitle }}</v-card-title>
      <validation-observer ref="closure">
        <o-date-time-range-filter
          v-model="modifiedTemporaryClosure"
          :validation-ref="'dateTimeClosure'"
          :ref="'dateTimeClosure'"
        />
        <v-col>
          <validation-provider rules="required" v-slot="{ errors }" :name="$t('location.locations')">
            <o-select-locations
              v-model="modifiedTemporaryClosure.locations"
              :error-messages="errors"
              :hide-details="false"
              :items="locations"
              :name="$t('location.locations')"
              :multiple="true"
              :clearable="true"
              :selectAll="true"
            />
          </validation-provider>
        </v-col>
      </validation-observer>
      <v-card-actions class="pa-0">
        <v-btn color="primary" tile style="width: 50%" @click="confirm()">{{ $t('location.confirm') }}</v-btn>
        <v-btn color="secondary" class="ml-0" style="width: 50%" tile @click="close()">
          {{ $t('location.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { displayMessage } from '../../helpers/helper'
  import ODateTimeRangeFilter from '../../components/inputs/ODateTimeRangeFilter.vue'

  export default {
    name: 'locationGlobalSpecialClosuresDialog',
    components: {
      'validation-provider': ValidationProvider,
      'validation-observer': ValidationObserver,
      ODateTimeRangeFilter,
    },
    props: {
      title: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      temporaryClosure: {
        type: Object,
        default() {
          return { begin: undefined, end: undefined, locations: [] }
        },
      },
      locations: {
        type: Array,
        default() {
          return []
        },
      },
    },
    data() {
      return {
        modifiedTemporaryClosure: { ...this.temporaryClosure },
      }
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      modalTitle() {
        return this.title ?? this.$t('components.modalConfirmation.defaultTitle')
      },
    },
    methods: {
      async confirm() {
        try {
          const success = (await this.$refs.closure.validate()) && (await this.$refs.dateTimeClosure.validate())
          if (success) {
            this.$emit('confirm', this.modifiedTemporaryClosure)
            this.show = false
          } else {
            displayMessage(this.$t('location.checkFormFields'))
          }
        } catch (error) {
          console.log(error)
          displayMessage(error.message || this.$t('location.checkFormFields'))
        }
      },
      close() {
        this.$emit('close')
        this.show = false
      }
    },
  }
</script>
